import { api } from "./axios";
import type { Household, HouseholdDetail } from "@/types/household";

export type HouseholdCreatePayload = {
  household_name: string;
  anniversary_date?: string | null;
  hide_anniversary_year?: boolean;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  phone?: string | null;
  email?: string | null;
};

export type AssignMemberToHouseholdPayload = {
  member_id: string;
  relationship_to_household?: string | null;
  is_head_of_household: boolean;
};

export async function getHouseholds(churchId: string): Promise<Household[]> {
  const response = await api.get(`/api/churches/${churchId}/households`);
  return response.data;
}

export async function getHouseholdById(
  churchId: string,
  householdId: string
): Promise<HouseholdDetail> {
  const response = await api.get(
    `/api/churches/${churchId}/households/${householdId}`
  );

  return response.data;
}

export async function createHousehold(
  churchId: string,
  payload: HouseholdCreatePayload
): Promise<Household> {
  const response = await api.post(
    `/api/churches/${churchId}/households`,
    payload
  );

  return response.data;
}

export async function assignMemberToHousehold(
  churchId: string,
  householdId: string,
  payload: AssignMemberToHouseholdPayload
) {
  const response = await api.post(
    `/api/churches/${churchId}/households/${householdId}/members`,
    payload
  );

  return response.data;
}

export async function getHouseholdsNeedingAttention(
  churchId: string
): Promise<Household[]> {
  const response = await api.get(
    `/api/churches/${churchId}/households/attention`
  );

  return response.data;
}

export type HouseholdDeletionStatus = { can_delete: boolean; reasons: string[]; will_delete_assessment_history: boolean };

export async function updateHousehold(churchId: string, householdId: string, payload: HouseholdCreatePayload): Promise<Household> {
  return (await api.patch(`/api/churches/${churchId}/households/${householdId}`, payload)).data;
}

export async function getHouseholdDeletionStatus(churchId: string, householdId: string): Promise<HouseholdDeletionStatus> {
  return (await api.get(`/api/churches/${churchId}/households/${householdId}/deletion-status`)).data;
}

export async function deleteHousehold(churchId: string, householdId: string, deleteAssessmentHistory = false): Promise<void> {
  await api.delete(`/api/churches/${churchId}/households/${householdId}`, { params: { delete_assessment_history: deleteAssessmentHistory } });
}

export async function removeMemberFromHousehold(churchId: string, householdId: string, memberId: string) {
  return (await api.delete(`/api/churches/${churchId}/households/${householdId}/members/${memberId}`)).data;
}
